import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { MenuItemFormData } from "../DishUpdatePage/DishUpdatePage";
import { MenuTypeProxy } from "@me-team/host/main/graphql/types";
import { useScrollToErrorMeMenu } from "@me-team/host/src/utils/useScrollToErrorMeMenu";
import { getMenuTypeEnums } from "../AllMenusPage/menuEnumMappings";

interface CreateMenuItemFormEffectsProps {
    pickedCategoryIds?: number[];
    menuTypes?: MenuTypeProxy[];
}

const CreateMenuItemFormEffects: React.FC<CreateMenuItemFormEffectsProps> = ({ pickedCategoryIds, menuTypes }) => {
    const { setFieldValue, submitCount, errors } = useFormikContext<MenuItemFormData>();

    useScrollToErrorMeMenu({ submitClickedCount: submitCount, errors });

    useEffect(() => {
        if (menuTypes) {
            setFieldValue("types", getMenuTypeEnums(menuTypes));
        }
    }, [menuTypes, setFieldValue]);

    useEffect(() => {
        if (pickedCategoryIds) {
            setFieldValue("categories", pickedCategoryIds);
        }
    }, [pickedCategoryIds, setFieldValue]);

    return null;
};

export default CreateMenuItemFormEffects;
